// Sterling formatting for prices held in pence. The one formatter for the
// public site (cards, detail, tray, order page): "£14.50", "£1,638.00".
// Only ever called with a real price — a nil price renders the honest
// "Price on request" / "Estimate available once pricing is confirmed" copy
// instead, never a guessed figure and never a non-sterling currency.

const GBP = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" })

export function formatPence(pence: number) {
  return GBP.format(pence / 100)
}

/** Admin (M7): "£14.50", or the fallback when there is no price. */
export function formatPenceOr(pence: number | null | undefined, fallback = "—") {
  return pence === null || pence === undefined ? fallback : formatPence(pence)
}

